/**
 * Single source of truth for the patient case claim / share URL.
 *
 * Both the printed text on the Visit Prep PDF and the QR target derive from the
 * SAME base, so they can never drift apart again (previously the PDF printed
 * "orella.health/md" while the QR opened the raw Vercel app URL).
 *
 * VITE_CLAIM_BASE_URL points at the branded front door
 * (orellahealth.com/claimcase). THAT PAGE HAS SHIPPED - the orella-website repo
 * carries both /claimcase (share-code entry form) and /claimcase/[code] (opens
 * the case with the code already applied). The default below is therefore the
 * correct production value and no override is needed.
 *
 * Do NOT point this back at a raw Vercel host. That was the workaround for the
 * months the page did not exist, and pointing one surface at it while another
 * kept the branded host is exactly how the drift above happened.
 *
 * EVERY physician-facing destination in this app derives from here: the Visit
 * Prep PDF (QR + printed text), the code screen QR, the wallet pass QR, the
 * native share sheet, and the share email and SMS in ShareScreen. Add a new
 * one and it derives from here too.
 */
const CLAIM_BASE = (import.meta.env.VITE_CLAIM_BASE_URL || 'https://orellahealth.com/claimcase')
  .replace(/\/+$/, '')

// Functional target: {base}/{shareCode} — works for /claimcase/{code} and /share/{code}
export function buildClaimUrl(shareCode) {
  return shareCode ? `${CLAIM_BASE}/${shareCode}` : CLAIM_BASE
}

// ★★★ THE PROVIDER SIGN-UP FRONT DOOR. Separate base on purpose: CLAIM_BASE is
//   orellahealth.com/claimcase, and /signup does not hang off it.
//   MEASURED 2026-09-10: md.orellahealth.com/signup -> 200; md.orella.health -> 000
//   (no DNS). Five call sites hardcoded the dead one -- D439 -- including the email
//   and SMS a patient sends their own doctor with a live share code. They now ask.
// ★ ONE host string, three doors. The MD panel's root is the base; /signup hangs
//   off it, so a host change moves both and cannot move only one.
const MD_PANEL_BASE = (import.meta.env.VITE_MD_PANEL_URL || 'https://md.orellahealth.com')
  .replace(/\/+$/, '')

// The physicians' front door (the "For Physicians" link on the patient landing page).
export function mdPanelUrl() {
  return MD_PANEL_BASE
}

// The provider sign-up page a patient invites their doctor to.
export function signupUrl() {
  return `${MD_PANEL_BASE}/signup`
}

// Display text = base without protocol (e.g. "orellahealth.com/claimcase")
export const CLAIM_DISPLAY = CLAIM_BASE.replace(/^https?:\/\//, '')

export { CLAIM_BASE }
